import './App.css';
import { Route, Routes } from 'react-router-dom';
import HomePage from './components/HomePage/HomePage';
import AboutPage from './components/AboutPage/AboutPage';
import TreatmentsPage from './components/TreatmentsPage/TreatmentsPage';
import AppointmentPage from './components/AppointmentPage/AppointmentPage';
import QuickAccess from './components/QuickAccess/QuickAccess';
import ContactPage from './components/ContactPage/ContactPage';
import WhyUsSection from './components/WhyUsSection/WhyUsSection';

function App() {
  return (
    <>

      <Routes>
        <Route path='/' element={<HomePage/>}/>
        <Route path='/hakkimizda' element={<AboutPage/>}/>
        <Route path='/uzmanliklar' element={<TreatmentsPage/>}/> 
        <Route path='/randevu-al' element={<AppointmentPage/>}/> 
                <Route path='/iletisim' element={<ContactPage/>}/> 
                                <Route path='/whyUsSection' element={<WhyUsSection/>}/> 


        
      </Routes>
<QuickAccess/>
    </>
  );
}

export default App;